import React from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import { Toolbar, Box } from '@mui/material';
import { Theme } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

import HeaderStatusBar from './HeaderStatusBar';
import {
	HEADER_BAR_PAGE_TITLE,
	HEADER_BAR_BACK_ACTION,
	HEADER_BAR_RIGHT_CONTENT,
} from './Portals/targets';

import { Routes } from 'routing';

const HeaderBar = () => {
	const location = useLocation();
	const isStatusBarVisible = !location.pathname.includes(Routes.ACCOUNT);

	const classes = useStyles(isStatusBarVisible);
	return (
		<>
			<Switch>
				<Route path={Routes.ACCOUNT} component={() => null} />
				<Route component={HeaderStatusBar} />
			</Switch>
			<Toolbar className={classes.toolbar}>
				<Box className={classes.toolbarLeft} id={HEADER_BAR_BACK_ACTION}></Box>
				<Box className={classes.toolbarRight} id={HEADER_BAR_RIGHT_CONTENT}></Box>
			</Toolbar>
			<div className={classes.stickyHeader}>
				<div id={HEADER_BAR_PAGE_TITLE} />
			</div>
		</>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		toolbar: {
			background: theme.palette.background.paper,
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'stretch',
			borderBottomWidth: '1px',
			borderBottomColor: theme.palette.border.paper,
			borderBottomStyle: 'solid',
			position: 'sticky',
			top: (isStatusBarVisible) => (isStatusBarVisible ? '32px' : 0),
			zIndex: 1101,
		},
		toolbarLeft: {
			flex: 1,
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'flex-start',
		},
		toolbarRight: {
			flex: 1,
			display: 'flex',
			flexDirection: 'row',
			alignItems: 'center',
			justifyContent: 'flex-end',
		},
		stickyHeader: {
			position: 'sticky',
			zIndex: 1100,
			top: (isStatusBarVisible) => (isStatusBarVisible ? '95px' : '63px'),
			[theme.breakpoints.down('sm')]: {
				position: 'relative',
				top: '0 !important',
			},
		},
	}),
);

export default HeaderBar;
